import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeHeading4,
  BaSeParagraph,
  BaSeButton,
  BaSeIcon,
  BaSeTheme,
} from '@base/react';
import {
  ResultContent,
  ResultSearchCertificate,
  WrapperButtonCertificate,
} from './resultado-styled';
import { Title } from '../../components/title/title';

export const CertificadoNaoEncontrado = () => {
  const { navigateTo } = Sebrae.useRouter();
  const { azulSebrae36 } = BaSeTheme.colors.institucionais;
  const { erro35 } = BaSeTheme.colors.feedbackInterface;
  return (
    <div>
      <Title
        titulo="Certificados Sebrae"
        subtitulo=""
        paddingContent="16px"
        paddingSubtitulo="16px"
      />
      <ResultContent>
        <ResultSearchCertificate>
          <BaSeIcon
            name="times-circle"
            description="certificado invalido"
            color={erro35}
          />
          <BaSeHeading4>Certificado não localizado</BaSeHeading4>
          <BaSeParagraph>
            O link fornecido não é de um certificado existente.
          </BaSeParagraph>
          <BaSeParagraph>
            Você pode visualizar todos os certificados clicando no link abaixo.
          </BaSeParagraph>

          <WrapperButtonCertificate>
            <BaSeButton
              buttonType="button"
              color={azulSebrae36}
              onClick={() => navigateTo(`/certificados`)}
              size="medium"
              type="primary"
              value="Meus certificados"
              width="176"
            />
            <BaSeButton
              buttonType="button"
              color={azulSebrae36}
              onClick={() =>
                navigateTo(
                  'https://www.sebrae.com.br/sites/PortalSebrae/faleconosco',
                )
              }
              size="medium"
              type="secondary"
              value="Fale conosco"
              width="176"
            />
          </WrapperButtonCertificate>
        </ResultSearchCertificate>
      </ResultContent>
    </div>
  );
};
